'use client';

import * as Dialog from '@radix-ui/react-dialog';
import { Cross2Icon } from '@radix-ui/react-icons';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { Heading } from './heading';

interface ModalProps {
  triggerElement?: ReactNode;
  title: string;
  children: ReactNode;
  isOpen?: boolean;
  onOpenChange?: Dialog.DialogProps['onOpenChange'];
  className?: string;
}

export function Modal({
  triggerElement,
  title,
  children,
  isOpen,
  onOpenChange,
  className,
}: ModalProps) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      {triggerElement && (
        <Dialog.Trigger asChild>{triggerElement}</Dialog.Trigger>
      )}

      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-neutral-50 opacity-80 z-[9999]" />
        <Dialog.Content
          className={twMerge(
            'w-[600px] max-w-[90vw] bg-new-neutral-white fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 p-8 rounded-2xl z-[999999] shadow-lg max-h-[90vh] overflow-auto',
            className,
          )}
        >
          <Dialog.Title className="mt-10" asChild>
            <Heading level={2} size={40}>
              {title}
            </Heading>
          </Dialog.Title>
          {children}
          <Dialog.Close asChild>
            <button
              className="flex justify-center items-center p-0 bg-transparent border-none w-8 h-8 absolute top-5 right-5 cursor-pointer"
              aria-label="Close"
            >
              <Cross2Icon className="w-6 h-6" />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
